import helpers from './helpers';
import tool from './tool';

export default function initGlobalInkive () {
  helpers();
  tool();
}
